// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6460) return "static/chunks/6460-2eb57a1c832dbf07.js";
	if (chunkId === 2554) return "static/chunks/2554-63f6fa1c9aa6ca8e.js";
	if (chunkId === 2744) return "static/chunks/2744-c03e87a54eb5c272.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"928":"7c09d4dc","3443":"89ddd23d","7272":"da458701","8448":"425a1fef"}[chunkId] || chunkId) + "." + {"928":"e14ed48d7e28c2e5","1622":"ae69b97dc8489b6d","2146":"f55ce0fb7ced941f","3443":"2db415be3218265c","5554":"50e630de75c799c2","6606":"4b5bf6ab34ab937c","7272":"e93262b273715cfb","8448":"bac5196603604d1d"}[chunkId] + ".js";
};